// Phase 5.4 — Serbian script preference (Cyrillic vs Latin). Serbian is ONE language
// (code "sr"); this only chooses which script the learning output uses. Default Cyrillic.
import { SERBIAN_SCRIPTS } from "@/lib/languages";

export default function SerbianScriptSelect({ value = "cyrillic", onChange, testid = "serbian-script-select" }) {
  return (
    <div className="mt-3" data-testid={`${testid}-wrap`}>
      <label className="text-xs font-bold uppercase tracking-widest">Serbian script</label>
      <div className="grid grid-cols-2 gap-2 mt-1">
        {SERBIAN_SCRIPTS.map((s) => (
          <button
            type="button"
            key={s.value}
            onClick={() => onChange(s.value)}
            data-testid={`${testid}-${s.value}`}
            className={`border-2 border-ink rounded-xl p-2 text-sm font-cabinet font-bold transition-all ${
              value === s.value ? "bg-mint shadow-hard-sm -translate-y-0.5" : "bg-white"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}
